<script>
  // Stores
  import { contactRecordsStore, profileRecordsStore } from "../../stores";
  import { matchedLinksWithVisibilityStore as links } from "./stores";
  // Components
  import SocialButton from "@sourcewhale/shared/svelte-design-system/components/atoms/SocialButton.svelte";
  import CrmButton from "./CrmButton.svelte";

  const profileMeta = profileRecordsStore.meta;
  const contactMeta = contactRecordsStore.meta;

  // Toggle hidden or non hidden items
  export let showHidden = false;
  const shouldShow = (record) =>
    (!showHidden && record.show) || (showHidden && !record.show);
</script>

{#if !showHidden && $profileMeta.fetching && !$profileMeta.firstFetchDone && $contactMeta.fetching && !$contactMeta.firstFetchDone}
  {#each Array(3) as _}
    <SocialButton skeleton={true} size="xs" />
  {/each}
  {#each Array(3) as _}
    <SocialButton skeleton={true} size="xs" />
  {/each}
{:else}
  {#each Object.entries($links) as [key, record]}
    {#if shouldShow(record) && record.type === "social"}
      <SocialButton
        icon={record.icon}
        color={record.color}
        href={key}
        alt="social-link"
        size="xs"
      />
    {/if}
  {/each}
  {#each Object.entries($links) as [key, record]}
    {#if shouldShow(record) && record.type === "crm"}
      <CrmButton src={record.image} href={record.crmLink} alt={key} size="xs">
        <!-- TODO: work out why tooltips get squashed as you go right -->
        In {record.title}
        {#if record.syncAs}
          as a {record.syncAs}
        {/if}
        {#if record.company}
          <br />Company: {record.company}
        {/if}
        {#if record.sourcingDate}
          <br />Added: {record.sourcingDate}
        {/if}
        {#if record.modifiedDate}
          <br />Last activity: {record.modifiedDate}
        {/if}
      </CrmButton>
    {/if}
  {/each}
{/if}
